<template>
  <div class="list">
    <div class="nav level-item has-background-light">
      <figure>
        <img class="logo" src="../assets/images/logo.png" />
      </figure>
      <router-link :to="{ name: 'login' }">
        <span class="icon is-small has-text-primary">
          <i class="fas fa-door-open"></i>
        </span>
      </router-link>
    </div>
    <div class="body columns is-centered is-vcentered">
      <div class="column is-full-mobile is-four-fifths-desktop">
        <div class="section has-background-white">
          <h1 class="content has-text-centered is-size-5">
            Lista de aprovação
          </h1>
          <div
            class="box is-hidden-mobile title-bar has-text-weight-bold has-background-success has-text-white"
          >
            <div class="columns is-marginless">
              <div class="column is-paddingless">
                <div class="columns is-marginless">
                  <div class="column is-2 is-paddingless">
                    <p>Nº</p>
                  </div>
                  <div class="column is-5 is-paddingless">
                    <p>Nome do solicitante</p>
                  </div>
                  <div class="column is-5 is-paddingless">
                    <p>Departamento</p>
                  </div>
                </div>
              </div>
              <div class="column is-paddingless">
                <div class="columns is-marginless">
                  <div class="column is-paddingless">
                    <p>Tipo de solicitação</p>
                  </div>
                  <div class="column is-paddingless">
                    <p class="has-text-centered-desktop">Data da solicitação</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ListItem
            v-for="(order, index) in data"
            :key="order.docNum"
            v-bind="order"
            :index="index"
          />
          <div class="level-item" v-if="loading">
            <div class="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ListItem from "@/components/ListItem.vue";
import { list } from "../repository";

export default {
  name: "home",
  components: {
    ListItem,
  },
  data() {
    return {
      data: [],
      loading: false,
    };
  },
  created() {
    if (window.sessionStorage.getItem("isLogged") === null) {
      this.$router.push({ name: "login" });
      return;
    }

    const userId = window.localStorage.getItem("userId");
    this.getList(userId);
  },
  methods: {
    async getList(userId) {
      try {
        this.loading = true;
        const { data } = await list(userId);
        this.data = data;
        data.map(this.setItemToSession);
      } catch (err) {
        console.log(err);
        this.hasError = true;
      } finally {
        this.loading = false;
      }
    },
    setItemToSession(item) {
      if (sessionStorage.getItem(item.docNum)) {
        sessionStorage.removeItem(item.docNum);
      }
      sessionStorage.setItem(item.docNum, JSON.stringify(item));
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  min-height: 100vh;
}

.section {
  padding: 1.5rem 1rem;
}

.content {
  margin-bottom: 2rem;
}

@media screen and (max-width: 768px) {
  .columns.is-vcentered {
    align-items: normal;
  }
}

.nav {
  height: 63px;
  margin-bottom: 0;
}

@media screen and (min-width: 769px) {
  .nav {
    justify-content: flex-start;
    padding-left: 5rem;
  }
}

.column {
  padding-top: 0;
  padding-bottom: 0;
}

.columns {
  padding-left: 0;
  padding-right: 0;
  margin: 0 -0.75rem;
}

@media screen and (max-width: 768px) {
  .columns.is-vcentered {
    align-items: normal;
  }
}

.logo {
  height: 40px;
}

.title-bar {
  margin-bottom: 1rem;
}

.box {
  padding: 1rem;
  border-radius: 0;
}

@media (min-width: 769px) {
  .box {
    padding: 1rem 2rem;
  }
}

span.icon {
  .fa-door-open {
    position: absolute;
    right: 1rem;
    top: 1.5rem;
  }
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  border: 6px solid #62ba46;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #62ba46 transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
